import { StatusLoading } from 'common/constants/statusLoading';
import { CreateSavedFilter } from 'dataSources/Typicode/savedFilters';

export interface SavedFilter extends CreateSavedFilter {
  statusLoading: StatusLoading;
  normalizedFilter?: any;
}

export interface SavedFilterData {
  [key: number]: SavedFilter;
}

export const STATE = 'SAVED_FILTERS';
export interface IState {
  savedFilters: {
    statusLoading: StatusLoading;
    data: SavedFilterData;
  };
  deletingFilter: {
    statusLoading: StatusLoading;
  };
  savingFilter: {
    statusLoading: StatusLoading;
  };
  gettingFilter: {
    statusLoading: StatusLoading;
  };
  activeFilter: {
    id: number;
  };
  updatingFilter: {
    id: number;
  };
}
